import {generatePath} from 'react-router';

import {isNotNil} from 'ramda';

import {VehicleItem} from '../../../types/api/api';
import {overviewPath} from '../../../utils/routing';

const PRICE_REPORT_APP_BASE_URL = 'https://price-report.omnetic.com';

export function getBatchVehiclePriceReportHref(vehicleItem: VehicleItem): string | null {
  const idRequest = vehicleItem.priceReport?.idRequest;
  if (isNotNil(idRequest)) {
    const path = generatePath(overviewPath, {requestId: idRequest});
    return `${PRICE_REPORT_APP_BASE_URL}${path}`;
  }
  return null;
}
